module.exports = __webpack_public_path__ + "static/img/jigou-shandong-top.9d4aef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-shandong-top.png
// module id = 9LAQ
// module chunks = 2